module.exports = {
	"config": {
		"siteTitle": "Youcef EL KAMEL",
		"siteUrl": "http://layouceferie.fr",
		"description": "LaYouCeferie, une philosophie."
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.jsx",
				"ext": "jsx",
				"name": "404",
				"extname": ".jsx",
				"basename": "404.jsx",
				"dirname": "",
				"stem": "404",
				"path": "404.jsx"
			},
			"requirePath": "404.jsx",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "about",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "about",
				"stem": "index",
				"path": "about/index.jsx"
			},
			"requirePath": "about/index.jsx",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "confidentiality",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "confidentiality",
				"stem": "index",
				"path": "confidentiality/index.jsx"
			},
			"requirePath": "confidentiality/index.jsx",
			"path": "/confidentiality/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "contact",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "contact",
				"stem": "index",
				"path": "contact/index.jsx"
			},
			"requirePath": "contact/index.jsx",
			"path": "/contact/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/animalz",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/animalz",
				"stem": "index",
				"path": "work/animalz/index.jsx"
			},
			"requirePath": "work/animalz/index.jsx",
			"path": "/work/animalz/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/caoua",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/caoua",
				"stem": "index",
				"path": "work/caoua/index.jsx"
			},
			"requirePath": "work/caoua/index.jsx",
			"path": "/work/caoua/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/incruizer",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/incruizer",
				"stem": "index",
				"path": "work/incruizer/index.jsx"
			},
			"requirePath": "work/incruizer/index.jsx",
			"path": "/work/incruizer/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work",
				"stem": "index",
				"path": "work/index.jsx"
			},
			"requirePath": "work/index.jsx",
			"path": "/work/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/lebonchoix",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/lebonchoix",
				"stem": "index",
				"path": "work/lebonchoix/index.jsx"
			},
			"requirePath": "work/lebonchoix/index.jsx",
			"path": "/work/lebonchoix/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/sociallyfox",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/sociallyfox",
				"stem": "index",
				"path": "work/sociallyfox/index.jsx"
			},
			"requirePath": "work/sociallyfox/index.jsx",
			"path": "/work/sociallyfox/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work/swipolitique",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "work/swipolitique",
				"stem": "index",
				"path": "work/swipolitique/index.jsx"
			},
			"requirePath": "work/swipolitique/index.jsx",
			"path": "/work/swipolitique/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0